import { render } from "./ViewDescargasEnviada.vue?vue&type=template&id=2e54c56d&scoped=true"
import script from "./ViewDescargasEnviada.vue?vue&type=script&lang=js"
export * from "./ViewDescargasEnviada.vue?vue&type=script&lang=js"

import "./ViewDescargasEnviada.vue?vue&type=style&index=0&id=2e54c56d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e54c56d"]])

export default __exports__